import { PERSISTED_SESSION_KEYS } from '@/shared/constants/storage-keys';

export const storage = {
  get(key: string): unknown {
    if (!PERSISTED_SESSION_KEYS.has(key)) return null;
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as unknown) : null;
    } catch {
      return null;
    }
  },

  set(key: string, value: unknown): void {
    if (!PERSISTED_SESSION_KEYS.has(key)) return;
    localStorage.setItem(key, JSON.stringify(value));
  },

  remove(key: string): void {
    if (!PERSISTED_SESSION_KEYS.has(key)) return;
    localStorage.removeItem(key);
  },

  getString(key: string): string | null {
    if (!PERSISTED_SESSION_KEYS.has(key)) return null;
    return localStorage.getItem(key);
  },

  setString(key: string, value: string): void {
    if (!PERSISTED_SESSION_KEYS.has(key)) return;
    localStorage.setItem(key, value);
  },

  clear(keys: string[]): void {
    keys.forEach((key) => {
      if (PERSISTED_SESSION_KEYS.has(key)) localStorage.removeItem(key);
    });
  },
};

/** Remove portal-owned browser data except retained auth/branch and UI preference keys. */
export function purgeNonSessionStorage(): void {
  if (typeof window === 'undefined') return;
  try {
    for (let index = localStorage.length - 1; index >= 0; index -= 1) {
      const key = localStorage.key(index);
      if (key && !PERSISTED_SESSION_KEYS.has(key)) localStorage.removeItem(key);
    }
  } catch {
    // Storage may be unavailable in private browsing; application features use APIs.
  }
}
